module.exports = __webpack_public_path__ + "static/media/aqaba-seza.10161e2e.jfif";